import { RootState } from "store/store";

export const getGridLayoutWidth = (state: RootState) =>
  state.gridLayoutSlice.gridWidth;

export const getGridLayoutHeight = (state: RootState) =>
  state.gridLayoutSlice.gridHeight;

export const getZoomLevel = (state: RootState) => state.gridLayoutSlice.zoom;

export const getShortcuts = (state: RootState) =>
  state.gridLayoutSlice.shortcuts;
